import { Type } from '@angular/core';
import { SliderItemModel } from '@libs/cms/models';
import { ImageSlideComponent, ContentTeaserComponent, HeroSlideComponent, ServiceTeaserComponent } from '../../items';

export type SlideComponent =
  | ImageSlideComponent
  | HeroSlideComponent
  | ServiceTeaserComponent
  | ContentTeaserComponent;

export const SlideItemComponentMap: Record<SliderItemModel['type'], Type<SlideComponent>> = {
  banner: ImageSlideComponent,
  hero: HeroSlideComponent,
  image: ImageSlideComponent,
  icon: ImageSlideComponent,
  serviceTeaser: ServiceTeaserComponent,
  contentTeaser: ContentTeaserComponent,
  galleryImage: ImageSlideComponent,
};
